import React from 'react'
import polilla from '../Imagenes/CroConstructorNoPala.png'

export const NoEncontrado = () => {
    const imagen = polilla;

  return (
    <>
    <center><h1>No se encontro esta pagina!</h1>
    <img className='square rotacion' src={imagen}></img>
    <p>Es probable que aun no este terminada, este en progreso o no exista!</p>
    </center>
    </>
  )
}
